import { render, staticRenderFns } from "./dialogRole.vue?vue&type=template&id=24ffea1d&"
import script from "./dialogRole.vue?vue&type=script&lang=js&"
export * from "./dialogRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports